import { useAssetListStore, useLayoutStore, useUserRolePermissionStore } from 'contexts/RootStore.context';
import React, { useEffect } from 'react';
import NoPermissionsPage from 'views/NoPermissionsPage';
import { AssetsDataTable } from './components/AssetDataTable';
import HeaderAssetSearch from './components/HeaderAssetSearch';
import { observer } from 'mobx-react';

export const AssetList = observer(() => {
  const { canViewAssets } = useUserRolePermissionStore()
  const { loadBaseData, loadAssets, totalCount, loading, reset, error } = useAssetListStore()
  const { setItemCount, setPageError } = useLayoutStore()

  useEffect(() => {
    const abortController = new AbortController();
    if (canViewAssets) {
      Promise.all([
        loadBaseData(),
        loadAssets(true)
      ])
        .finally(() => {
          if (abortController.signal.aborted) {
            reset();
          }
        });
    }

    return () => {
      abortController.abort();
      reset()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    setPageError(error)
  }, [error, setPageError])

  useEffect(() => {
    if (!loading) {
      setItemCount(totalCount, "Total Assets")
    }
  }, [loading, setItemCount, totalCount])


  if (!canViewAssets) {
    return <NoPermissionsPage />
  }

  return (
    <>
      <HeaderAssetSearch />
      <AssetsDataTable />
    </>
  );
})
